var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-container" },
    [
      _c("mq-layout", { attrs: { mq: "desktop" } }, [
        _c("h2", [_vm._v("Choose an item to add to your cart:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upsell-item-container menu-items" },
          [
            !_vm.upsellItems ? _c("BaseLoader") : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.upsellItems(), function(item) {
              return _c(
                "div",
                { key: item.id, staticClass: "menu-card" },
                [
                  _c("menu-item", {
                    attrs: { item: item, afterClick: _vm.closeModal }
                  })
                ],
                1
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "mq-layout",
        { staticClass: "full-width", attrs: { mq: ["mobile", "tablet"] } },
        [
          _c("menu-item-rows", {
            attrs: { items: _vm.upsellItems(), afterClick: _vm.closeModal }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upsell-options" },
        [
          _c("BaseButton", {
            attrs: { title: "No, thank you.", bigBtn: true },
            nativeOn: {
              click: function($event) {
                return _vm.hideUpsell($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ae1d6d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae1d6d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/Upsell.vue
// module id = null
// module chunks = 